import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {HeaderMainPageComponent, ListMainPageComponent} from '@shared/module/main-page/component';
import {SerenityDirectiveModule} from '@directive';
import {TranslateModule} from '@ngx-translate/core';
import {SerenityFormsModule} from '@form';
import {ReactiveFormsModule} from "@angular/forms";
import {DialogModule} from '@dialog';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {SerenityPipeModule} from "@pipe";
import {MatBadgeModule} from "@angular/material/badge";
import {MatFormField, MatOption, MatSelect} from "@angular/material/select";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import { ConfirmDialogModule } from '@shared/component/confirm-dialog/confirm-dialog.module';


@NgModule({
  declarations: [
    ListMainPageComponent,
    HeaderMainPageComponent
  ],
  exports: [
    ListMainPageComponent,
    HeaderMainPageComponent
  ],
    imports: [
        CommonModule,
        SerenityDirectiveModule,
        TranslateModule,
        SerenityFormsModule,
        DialogModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        SerenityPipeModule,
        MatBadgeModule,
        MatSelect,
        MatOption,
        MatFormField,
        MatButtonToggleGroup,
        MatButtonToggle,
        NgOptimizedImage,
        ConfirmDialogModule
    ]
})
export class MainPageModule {
}
